// extracted by mini-css-extract-plugin
export default {"leftArrow":"Arrows_leftArrow__cHuJI","RightArrow":"Arrows_RightArrow__+4dln"};